import React, { useState } from "react";
import Modal from "react-modal";
import { Server } from "../services/server";
import { container } from "../services/container";
import { HttpError } from "../errors/httpError";
import { FORBIDDEN } from "http-status-codes";
import { Translate } from "../services/translate";

export function EventPasswordModal({
  show,
  onDismissModal,
  eventId,
}: {
  eventId: string;
  show: boolean;
  onDismissModal(): void;
}) {
  const translate = container.get(Translate);
  const [passwordValue, setPasswordValue] = useState("");
  let [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  async function onFormSubmit(event: React.FormEvent) {
    event.preventDefault();

    setSubmitError(null);

    const server = container.get(Server);
    const trimmedPassword = passwordValue.trim();

    if (!trimmedPassword) {
      setSubmitError(translate.translate("passwordModal.passwordIsRequired") as string);
      return;
    }

    setIsLoading(true);
    try {
      // Will return 200 on success
      await server.post(`ticket-events/${eventId}/password`, { password: passwordValue });

      onDismissModal();
    } catch (error) {
      setIsLoading(false);

      console.error(error);

      if (error instanceof HttpError) {
        if (error.response.status === FORBIDDEN) {
          setSubmitError(translate.translate("passwordModal.incorrectPassword") as string);
        } else {
          const body = await error.response.json();
          setSubmitError(body.message || JSON.stringify(body).slice(0, 120));
        }
      } else {
        setSubmitError(error.message);
      }
    }
  }

  return (
    <Modal
      isOpen={show}
      className={{
        base: `modal-content`,
        afterOpen: "modal-content-after-open",
        beforeClose: "modal-content-before-close",
      }}
      overlayClassName={{
        base: `modal-overlay modal-overlay-notice`,
        afterOpen: "modal-overlay-after-open",
        beforeClose: "modal-overlay-before-close",
      }}
    >
      <div className="event-password-modal">
        <div className="event-password-modal-title">{translate.translate("passwordModal.modalTitle")}</div>
        <div className="event-password-modal-summary">{translate.translate("passwordModal.modalSummary")}</div>
        <form onSubmit={onFormSubmit}>
          <div>
            <input
              value={passwordValue}
              onChange={(event) => setPasswordValue(event.currentTarget.value)}
              type="text"
              placeholder={translate.translate("passwordModal.inputPlaceholder") as string}
              disabled={isLoading}
            />
            {submitError && <div className="event-password-modal-error">{submitError}</div>}
            {isLoading && (
              <div className="event-password-modal-loading">
                {translate.translate("passwordModal.inProgressIndicator")}
              </div>
            )}
            {!isLoading && <button type="submit">OK</button>}
          </div>
        </form>
      </div>
    </Modal>
  );
}
